import React, { useEffect } from "react";
import GalleryCard from "./GalleryCard";
import { Link } from "react-router-dom";

const GalleryComp = ({ data, showCategories = false, gallery }) => {
  console.log(gallery, "gallery");

  const galleryData =
    gallery?.map((section) => ({
      title: section.title,
      subTitle: section.subTitle,
      images:
        section.images?.map((img) => ({
          type: img.mime?.startsWith("video") ? "video" : "image",
          src: img.url,
        })) || [],
    })) || [];

  // Homepage preview

  const previewImages = galleryData

    .flatMap((section) => section.images)

    .slice(0, 7);

  return (
    <section className="Chooseus">
      {!showCategories && (
        <>
          <p className="founder-subtitle">{data?.gallerySubTitle}</p>
          <h2 className="founder-title">
            {data?.galleryTitle?.split(" ").slice(0, -1).join(" ")}
            <span> {data?.galleryTitle?.split(" ").slice(-1).join(" ")}</span>
          </h2>
        </>
      )}

      {/* Homepage Preview */}
      {!showCategories && (
        <>
          <div className="gallery-box">
            <GalleryCard images={previewImages} />
          </div>

          <div className="gallery-btn">
            <Link to="/gallery">
              <button className="btn-outline">View More</button>
            </Link>
          </div>
        </>
      )}

      {/* Full Gallery Page */}
      {showCategories &&
        Object.keys(galleryData).map((key) => {
          const section = galleryData[key];

          return (
            <div key={key} className="gallery-category">
              <p className="founder-subtitle">— {section.subTitle}</p>

              <h2 className="founder-title">{section.title}</h2>

              <GalleryCard images={section.images} />
            </div>
          );
        })}
    </section>
  );
};

export default GalleryComp;
